import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from './token-storage.service';
import { Observable } from 'rxjs';
const API_URL = environment.apiUrl + 'academy-top-player';

@Injectable({
  providedIn: 'root'
})
export class AcademyTopPlayersService {
  authtoken: string;
  private httpOptions;
  constructor(private http: HttpClient, private token: TokenStorageService) {
    this.authtoken = this.token.getToken();
    this.httpOptions = {
      headers: new HttpHeaders()
        .set("Content-Type", "application/json")
        .set('Authorization', `Bearer ${this.authtoken}`)
    };
  }
  getAcademyTopPlayers(query): Observable<any> {
    return this.http.get(API_URL + query, this.httpOptions);
  }
  getAcademyTopPlayersDetails(id): Observable<any> {
    return this.http.get(API_URL + '/' + id, this.httpOptions);
  }
  updateAcademyTopPlayers(id, data): Observable<any> {
    return this.http.put(API_URL + '/' + id, data, this.httpOptions);
  }
  addAcademyTopPlayers(data): Observable<any> {
    return this.http.post(API_URL, data, this.httpOptions);
  }
}
